// Vuex Departments module mutations
import {
  FILL_LIST, TOGGLE_AGENT_IN_DEPARTMENT,
} from './mutations-types';

import { hDeepCopy, hToggleArrayItem } from '@/utils/helpers';

export default {
  [FILL_LIST](state, payload) {
    const _state = state;
    _state.list = payload.list || [];
  },

  [TOGGLE_AGENT_IN_DEPARTMENT](state, payload) {
    const list = hDeepCopy(state.list);
    const departmentIndex = list.findIndex(deparment => deparment.id === payload.department);

    if (departmentIndex !== -1) {
      const _state = state;
      const department = list[departmentIndex];
      const agentsAsArray = department.assigned_agents ? (department.assigned_agents).split(',') : [];
      const newAgentsGroup = ((hToggleArrayItem(agentsAsArray, String(payload.agent)))).join(',');

      // now mutate the state after magic above
      list[departmentIndex].assigned_agents = newAgentsGroup;
      _state.list = list;
    }
  },
};
